import { Button, DatePicker, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllCompany } from "../../redux/rtk/features/crm/company/companySlice";
import { loadAllContact } from "../../redux/rtk/features/crm/contact/contactSlice";
import { loadAllOpportunity } from "../../redux/rtk/features/crm/opportunity/opportunitySlice";
import { loadAllProduct } from "../../redux/rtk/features/crm/product/productSlice";
import {
	addSingleQuote,
	loadAllQuotePaginated,
} from "../../redux/rtk/features/crm/quote/quoteSlice";
import { loadAllQuoteStage } from "../../redux/rtk/features/crm/quoteStage/quoteStageSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { createPromoCode } from "../../redux/rtk/features/crm/promocode/createPromoCodeSlice";
import { message } from "antd"

import { getAllFranchises } from "../../redux/rtk/features/franchise/franchiseSlice";
import { fetchCompanyList, getPromoCodes, updatePromoCode } from "../../redux/rtk/features/crm/promocode/promoCodeSlice";
import { loadAllTaskPaginated } from "../../redux/rtk/features/crm/task/crmTaskSlice";
import { toast } from "react-toastify";
import dayjs from "dayjs"; // Ensure you're using Day.js (or Moment.js)
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
export default function CreatePromoForm({ onClose, createAs, editData }) {
	const [isEditing, setIsEditing] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [loader, setLoader] = useState(false);
	const { error, list } = useSelector((state) => state.promoCodes);
	const { list: franchiseList, isFetchingFranchises } = useSelector((state) => state.franchise);
	const { companyList, companyLoading } = useSelector((state) => state.promoCodes);


	useEffect(() => {
		if (editData) {
			setIsEditing(true);
			form.setFieldsValue({
				promocode: editData.promocode || "",
				amount: editData.amount ? String(editData.amount) : "",
				start_date: editData.start_date ? dayjs(editData.start_date) : null, 
				end_date: editData.end_date ? dayjs(editData.end_date) : null, 
				franchiseName: editData.assignee?.id || "",
			});
		}else {
			(async () => {
				
				const data = await dispatch(getAllFranchises({ status: true, page: 1, count: 10 }));
			})();
		}
	}, [editData, form]);
	
 
	const onCancel = () => {
		form.resetFields();
		onClose();
	};
	const { loading: quoteLoading } = useSelector((state) => state.quote);
	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
	};

	const handleSubmit = async (values) => {
		try {
			setLoader(true);
			const promoData = {
				promocode: values.promocode,
				amount: Number(values.amount),
				start_date: values.start_date ? values.start_date.toISOString() : null,
				end_date: values.end_date ? values.end_date.toISOString() : null, 
				availability: "Active",
				assigneeId: values.franchiseName,
			};
	
			if (isEditing) {
				await dispatch(updatePromoCode({ id: editData.id, values: promoData })).unwrap();
			} else {
				await dispatch(createPromoCode(promoData)).unwrap();
			}
	
			dispatch(getPromoCodes({ page: 1, pageSize: 10 }));
			form.resetFields();
			onClose();
		} catch (error) {
			console.error("Error submitting form:", error);
		} finally {
			setLoader(false);
		}
	};
	
	
	return (
		<div className='flex justify-center px-6 py-4'>
			<Form
				className='w-full'
				onFinish={handleSubmit}
				onFinishFailed={() => setLoader(false)}
				colon={false}
				layout='vertical'
				form={form}
				initialValues={
					createAs
						? {
							[createAs.name]: createAs.value,
						  }
						: {}
				}>
				<div className='flex justify-center gap-5'>
					<div className='w-1/2'>
						<Form.Item 
							label='Franchise' 
							name='franchiseName' 
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Franchise is Required." }
							]}>
							<Select
								style={{ width: "100%" }}
								loading={isFetchingFranchises}
								allowClear
								showSearch
								placeholder='Select Franchise Name'
							>
								{franchiseList?.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.franchiseName}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item
							style={{ width: "100%" }}
							label='Promocode'	
							name='promocode'
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Promocode is Required." },
								{ whitespace: true, message: "Promocode cannot be empty" },
								{ min: 3, message: "Promocode must be at least 3 characters" },
								{ max: 20, message: "Promocode cannot exceed 20 characters" },
							]}>
							<Input placeholder='Promocode' />
						</Form.Item>
						<Form.Item
							style={{ width: "100%" }}
							label='Amount'	
							name='amount'
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Amount is Required." },
								{ whitespace: true, message: "Amount cannot be empty" },
								{ pattern: /^[0-9]+$/, message: "Amount must be a number" },
								{ validator: (_, value) => {
									if (value && value <= 0) {
										return Promise.reject("Amount must be greater than 0");
									}
									return Promise.resolve();
								}}
							]}>
							<Input placeholder='Amount' />
						</Form.Item>
					</div>
					<div className='w-1/2'>
						<Form.Item
							label='Start Date'
							name='start_date'
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Start Date is Required." },
							]}>
							<DatePicker
								format="MM-DD-YYYY"
								style={{ width: "100%" }}
								disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
								placeholder='Select Start Date' 
							/>
						</Form.Item>
						<Form.Item
							label='End Date'
							name='end_date'
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "End Date is Required." },
								{ validator: (_, value) => {
									if (value && value.isBefore(dayjs().startOf('day'))) {
										return Promise.reject("End date cannot be in the past");
									}
									return Promise.resolve();
								}},
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue('start_date') === null || value.isAfter(getFieldValue('start_date'))) {
											return Promise.resolve();
										}
										return Promise.reject(new Error('End date must be after start date'));
									},
								}),
							]}>
							<DatePicker 
								format="MM-DD-YYYY"
								style={{ width: "100%" }}
								disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
								placeholder="Select End Date"
							/>
						</Form.Item>
					</div>
				</div>
				<div className='flex justify-center'>
					<div className='w-full'>
						<Form.Item label=''>
							<div className='flex items-center justify-end gap-2'>
								<Button
									size={"large"}
									type='danger'
									onClick={onCancel}
									className="btn-tertiary"
									>
									Cancel
								</Button>
								<Button
									size={"large"}
									htmlType='submit'
									loading={loader}
									className="btn-primary hover:border-[#E5383B]"
									>
									{isEditing ? "Update" : "Create"}
								</Button>
							</div>
						</Form.Item>
					</div>
				</div>
			</Form>
		</div>
	);
}
